import React, { useState, Fragment, useContext } from 'react';
import './Screens.scss';
import { AppContext } from "../../Context/AppContext";
// Material UI
import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from "@mui/material/Typography";

// Custom Plugins
import { customCloneDeep } from '../../Plugins/HelperFunctions';

const Screen12 = () => {
  const { screensData, setScreensData, setActiveScreen, setShowSnackbar, setSnackbarMessage } = useContext(AppContext)
  const [screen12, setScreen12] = useState(screensData.screen12);

  const handleChange = (e) => {
    let { name, value } = e.target;
    let errorName = `${name}Error`

    if (value === '' || value === undefined) {
      setScreen12({
        ...screen12,
        [name]: value,
        [errorName]: true
      });
    } else {
      setScreen12({
        ...screen12,
        [name]: value,
        [errorName]: false
      });
    }
  };

  // Form Validator
  const formValidator = () => {
    let inputs = ['address', 'city', 'state', 'zipCode'];
    let errors = { firstNameError: false, lastNameError: false, phoneError: false, };

    inputs.forEach((input) => {
      const errorName = `${input}Error`
      if (screen12[input] === '' || screen12[input] === undefined) {
        errors[errorName] = true
      }
    })

    setScreen12({
      ...screen12,
      ...errors
    });

    if (Object.values(errors).includes(true)) {
      return false
    }
    return true
  }

  const handleNext = () => {
    if (formValidator()) {
      let clonedScreensData = customCloneDeep(screensData);
      clonedScreensData.screen12 = screen12;
      setScreensData(clonedScreensData);

      setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);

    } else {
      setShowSnackbar(true);
      setSnackbarMessage('All required fields are not filled');
    }
  }

  const handlePrevious = () => {
    setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  }


  return (
    <Fragment>
      <div className="screen">
        <form>
          <Box className="screen__wrapper" >
            <Typography variant="subtitle1" component="p" >
              What is the vehicle pickup address?
            </Typography>

            <FormControl fullWidth>
              <TextField
                label="Address"
                variant="outlined"
                name="address"
                value={screen12.address}
                error={screen12.addressError}
                helperText={`${screen12.addressError ? 'Required' : ''}`}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="City"
                variant="outlined"
                name="city"
                value={screen12.city}
                error={screen12.cityError}
                helperText={`${screen12.cityError ? 'Required' : ''}`}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="State"
                variant="outlined"
                name="state"
                value={screen12.state}
                error={screen12.stateError}
                helperText={`${screen12.stateError ? 'Required' : ''}`}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Zip Code"
                variant="outlined"
                name="zipCode"
                value={screen12.zipCode}
                error={screen12.zipCodeError}
                helperText={`${screen12.zipCodeError ? 'Required' : ''}`}
                onChange={handleChange}
              />
            </FormControl>
          </Box>
        </form>
      </div>

      <Box className="screenBtnContainer" sx={{ pt: 3 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handlePrevious}
        >
          Previous
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
        >
          Next
        </Button>
      </Box>
    </Fragment>
  );
};

export default Screen12;
